import clsx from 'clsx';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import DrawerSkeleton from '../..';
import ServicesAction from '../../../Components/General/ServicesAction';
import Button from '../../../Components/UI/Button';
import Dropdown from '../../../Components/UI/Dropdown';
import { Input } from '../../../Components/UI/Input';
import Phone from '../../../Components/UI/Phone';
import useDoctor from '../../../Features/useDoctor';
import { convertIntoDate } from '../../../Helpers';
import { createPatientSchema } from '../../../Schema';
import { setSelectedService } from '../../../Store/serviceSlice';
import { gender } from '../../../data';
import DrawerHeader from '../../DrawerHeader';
import CreateAndViewServicesDrawer from '../../TodayAppointmentDrawer/RescheduleAppointment/CreateAndViewServicesDrawer';
import classes from './CreatePatientDrawer.module.css';
const initialValues = {
  countryCode: '',
  cellNumber: '',
  fullName: '',
  // lastName: '',
  email: '',
  gender: null,
  age: '',
  isOpd: true,
  appliedFees: [],
  emrNo: '',
  ageType: { label: 'Year(s)', value: 'Yrs' }
};

const dateOptions = [
  { label: 'Year(s)', value: 'Yrs' },
  {
    label: 'Day(s)',
    value: 'Day'
  },
  { label: 'Month(s)', value: 'Mon' }
];

const formatDateUnit = (date) => {
  if (date === 'Year(s)') return 'Yrs';
  else if (date === 'Month(s)') return 'Mon';
  else if (date === 'Day(s)') return 'Day';
};
const CreatePatientDrawer = ({
  show,
  setShow,
  onSubmit,
  cellNumber,
  setShow2,
  setPrevDrawerState,
  loading,
  data = null
}) => {
  const selectedServices = useSelector((state) => state?.serviceReducer?.selectedServices);
  const [showServiceDrawer, setShowServiceDrawer] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false); // New state to track if data has been set
  const { addOrEditServiceSubmit } = useDoctor();

  const { getAllServicesListing } = useDoctor();
  const toggleServiceDrawer = () => {
    setShowServiceDrawer((prev) => !prev);
  };
  useEffect(() => {
    if (show) getAllServicesListing();
  }, [show]);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues,
    validationSchema: createPatientSchema,
    onSubmit: (values, { resetForm }) => {
      const servicesTaken = selectedServices?.flatMap((item) =>
        Array(item?.quantity).fill(item?.serviceId)
      );
      const params = {
        ...values,
        isOpd: servicesTaken.includes(null),
        ...(data && { patientId: data?.id }),
        cellNumber: values?.cellNumber?.slice(2),
        patientName: values?.fullName,
        countryCode: `+${values?.cellNumber?.slice(0, 2)}`,
        appliedFees: servicesTaken.filter((data) => data != null),
        email: values?.email,
        gender: values?.gender?.value,
        dateOfBirth: convertIntoDate(values?.age, values?.ageType?.value)
      };
      delete params?.age;
      delete params?.ageType;
      onSubmit(params, () => {
        setShow();
        resetForm();
        //here empty all selected
        dispatch(setSelectedService([]));
        // { values: { ...initialValues, appliedFees: values.appliedFees } }
      });
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    isValid,
    dirty
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  useEffect(() => {
    //here cell number can be number or string don't confuse by name
    //Here we use show for checking either create patient is show or not bcz this component always mount
    if (show) {
      if (cellNumber && !data) {
        // debugger;
        if (!isNaN(parseInt(cellNumber))) {
          setValues({
            cellNumber
          });
        } else if (cellNumber.includes(' ')) {
          setValues({
            fullName: cellNumber
          });
        } else if (typeof cellNumber === 'string') {
          setValues({
            fullName: cellNumber
          });
        }

        return;
      } else if (data) {
        setValues({
          cellNumber: data?.cellNumber?.slice(1),
          // firstName: data?.patientName
          //   ? data?.patientName?.split(' ')[0]
          //   : data?.name?.split(' ')[0],
          // lastName: data?.patientName
          //   ? data?.patientName?.split(' ')[1]
          //   : data?.name?.split(' ')[1],
          fullName: data?.name,
          gender: gender?.find((ele) => ele?.label === data?.gender),
          age: +data?.age?.split(' ')[0],
          emrNo: data?.emrNo,
          email: data?.email,
          ageType: dateOptions?.find(
            (ele) => ele?.value === formatDateUnit(data?.age?.split(' ')[1])
          )
        });
        setIsDataLoaded(true); // Mark data as loaded
        return;
      } else {
        // resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
      }
    }
  }, [data, cellNumber, setValues, show]);
  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          setPrevDrawerState && setPrevDrawerState();
          setShow();
          setValues(initialValues);
          resetForm();
          dispatch(setSelectedService([]));
        }}>
        <form className={classes.form} onSubmit={handleSubmit}>
          <div className={classes.parentWrapper}>
            <DrawerHeader
              title={`${data ? 'Add To Queue' : 'Create Patient'}`}
              setShow={() => {
                resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                setShow();
              }}
              setShow2={() => {
                // resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                setShow2();
                dispatch(setSelectedService([]));
              }}
            />
            <div className={clsx(classes.wrapper, 'scrollbar1')}>
              <Row className={clsx(classes.grid)}>
                <Col xs={12}>
                  <Phone
                    id={'create-patient-cellNumber'}
                    name="Signup-cellNumber"
                    placeholder={'+92 XXX XXXXXXX'}
                    value={values.cellNumber}
                    onChange={(value) => handleChangeWithTouch('cellNumber', value)}
                    onBlur={() => setFieldTouched('cellNumber', true)} // Ensure touched state on blur
                    className={classes['mb-15']}
                    errorText={touched?.cellNumber && errors?.cellNumber} // Show error if touched
                    disabled={data?.cellNumber}
                  />
                </Col>
                <Col xs={12}>
                  <Input
                    id={'create-patient-fullname'}
                    placeholder="Enter Name"
                    label={'Name'}
                    value={values?.fullName}
                    setter={(e) => handleChangeWithTouch('fullName', e)}
                    errorText={touched?.fullName && errors?.fullName}
                    disabled={data?.name}
                  />
                </Col>

                {/* nested grid */}
                <Col md={12}>
                  <Row className={classes.nestedRow}>
                    <Col xs={12} sm={6}>
                      <Dropdown
                        id={'create-patient-gender-02'}
                        placeholder="Gender"
                        label={'Gender'}
                        onBlur={() => setFieldTouched('gender', false)}
                        value={values?.gender}
                        options={gender}
                        setter={(e) => handleChangeWithTouch('gender', e)}
                        errorText={touched?.gender && errors?.gender}
                        disabled={data?.gender}
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className={classes.ageGroup}>
                        <Input
                          id={'create-patient-age-0'}
                          type="number"
                          placeholder="Age"
                          label={'Age'}
                          value={values?.age}
                          containerClass={classes.ageInput}
                          setter={(e) => {
                            handleChangeWithTouch('age', e);
                          }}
                          errorText={touched?.age && errors?.age}
                          disabled={data?.age}>
                          <Dropdown
                            value={values?.ageType}
                            setter={(e) => {
                              handleChangeWithTouch('ageType', e);
                            }}
                            disabled={data}
                            placeholder=""
                            parentClass={classes.ageDropdown}
                            options={dateOptions}
                          />
                        </Input>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md={12}>
                  <Input
                    isOptional={true}
                    id={'create-patient-email01'}
                    placeholder="Enter Email"
                    label={'Email'}
                    value={values?.email}
                    setter={(e) => {
                      handleChangeWithTouch('email', e);
                    }}
                    errorText={touched?.email && errors?.email}
                    disabled={data}
                  />
                </Col>
                <Col md={12}>
                  <p className={classes.serviceLabel}>
                    Please select at least one service to proceed
                  </p>
                  <ServicesAction
                    isView={true}
                    isDrawerOpen={show}
                    // showServiceDrawer
                    show={show}
                    onView={() => {
                      toggleServiceDrawer();
                      //close the current drawer
                      setShow();
                    }}
                    onClick={() => {
                      toggleServiceDrawer();
                      setShow();
                    }}
                    value={values.appliedFees}
                    setter={(e) => {
                      setFieldValue('appliedFees', e);
                    }}
                  />
                  <p className={'errorText'}>
                    {touched?.appliedFees && errors?.appliedFees?.appliedFees}
                  </p>
                </Col>
              </Row>
            </div>
            <div className={classes.bottomAction}>
              <Button
                label={'Close'}
                variants="secondary"
                onClick={() => {
                  dispatch(setSelectedService([]));

                  setPrevDrawerState && setPrevDrawerState();
                  resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                  setShow(); // Close the drawer
                }}
              />
              <Button
                variants="primary"
                loading={loading}
                type="submit"
                label={`Add New Patient`}
                disabled={
                  !(isValid && (dirty || isDataLoaded) && selectedServices?.length > 0) || loading
                } // Enable if valid and either dirty or data is loaded
              />
            </div>
          </div>
        </form>
      </DrawerSkeleton>
      <CreateAndViewServicesDrawer
        setShow2={() => {
          setShow();
        }}
        show={showServiceDrawer}
        resetOfPrevDrawer={() => {
          resetForm();
        }}
        setShow={() => {
          toggleServiceDrawer();
        }}
        onSubmit={addOrEditServiceSubmit}
      />
    </>
  );
};

export default CreatePatientDrawer;
